<template>
    <div>
        <div class="nodata-box">
            {{this.$t('langNew.zwsj')}}
        </div>
    </div>
</template>
<script>
export default {
    name: 'noData',
    data () {
        return {
            msg: ''
        }
    }
}
</script>
<style>
    .nodata-box{
        padding: .8rem 0;
        color: #999;
        font-size: .36rem;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/noData.vue